import React from "react";
import { getStageColorV2 } from "../../../../utils";
import makeStyles from "@material-ui/core/styles/makeStyles";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import StageDescription from "./StageDescription";

const useStyles = makeStyles((theme: any) => ({
  menuItem: {
    width: 160,
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderBottom: ({ isLastStage }: any) => {
      return isLastStage ? "none" : `1px solid ${theme.palette.custom.actions}`;
    },
    "&:hover": {
      backgroundColor: theme.palette.brand.blueGrey,
    },
  },
  stageColor: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    backgroundColor: ({ stage }) => getStageColorV2(stage.value, theme),
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(1),
    borderRadius: "100%",
  },
}));

export default React.forwardRef(function StageSelectorItem(
  { stage, totalStages, index, onClick }: any,
  ref
) {
  const isLastStage = totalStages === index + 1;
  const classes = useStyles({ stage, isLastStage });

  return (
    <MenuItem className={classes.menuItem} onClick={() => onClick(stage.value)}>
      <div className={classes.stageColor} />
      <Typography variant="body2">
        {stage["shortName"] || stage.label}
      </Typography>
      <StageDescription stage={stage} />
    </MenuItem>
  );
});
